<template>
  <CBox width="100%">
    <!-- Avaliacao: aberta por padrao -->
    <CBox
      v-if="relatorio.assessment"
      bg="#FFFFFF"
      border="1px solid #DADADA"
      borderRadius="8px"
      mb="16px"
    >
      <CFlex
        as="button"
        type="button"
        width="100%"
        alignItems="center"
        p="20px"
        bg="transparent"
        border="none"
        cursor="pointer"
        textAlign="left"
        :aria-expanded="secoes.avaliacao.aberta ? 'true' : 'false'"
        @click="alternar('avaliacao')"
      >
        <OmtIcons
          name="file-medical"
          size="lg"
          color="var(--colors-light-primary-navy-blue)"
          mr="8px"
        />
        <OmtTypography
          as="h2-bold"
          color="var(--colors-light-primary-navy-blue)"
        >
          Avaliação detalhada
        </OmtTypography>
        <OmtIcons
          name="chevron-down"
          ml="auto"
          :style="`transition: transform 0.3s ease; transform: rotate(${secoes.avaliacao.aberta ? '180deg' : '0deg'})`"
        />
      </CFlex>
      <component
        :is="secoes.avaliacao.animada ? 'CCollapse' : 'CBox'"
        v-bind="secoes.avaliacao.animada ? { isOpen: secoes.avaliacao.aberta } : {}"
      >
        <OmtTypography
          as="p1"
          color="#4E4E4E"
          px="20px"
          pb="20px"
          class="texto-relatorio"
        >
          {{ relatorio.assessment }}
        </OmtTypography>
      </component>
    </CBox>

    <!-- Recomendacoes: lista com icone por tipo, aberta por padrao -->
    <CBox
      v-if="recomendacoes.length"
      bg="#FFFFFF"
      border="1px solid #DADADA"
      borderRadius="8px"
      mb="16px"
    >
      <CFlex
        as="button"
        type="button"
        width="100%"
        alignItems="center"
        p="20px"
        bg="transparent"
        border="none"
        cursor="pointer"
        textAlign="left"
        :aria-expanded="secoes.recomendacoes.aberta ? 'true' : 'false'"
        @click="alternar('recomendacoes')"
      >
        <OmtIcons
          name="clipboard-list-check"
          size="lg"
          color="var(--colors-light-primary-navy-blue)"
          mr="8px"
        />
        <OmtTypography
          as="h2-bold"
          color="var(--colors-light-primary-navy-blue)"
        >
          Recomendações
        </OmtTypography>
        <OmtIcons
          name="chevron-down"
          ml="auto"
          :style="`transition: transform 0.3s ease; transform: rotate(${
            secoes.recomendacoes.aberta ? '180deg' : '0deg'
          })`"
        />
      </CFlex>
      <component
        :is="secoes.recomendacoes.animada ? 'CCollapse' : 'CBox'"
        v-bind="secoes.recomendacoes.animada ? { isOpen: secoes.recomendacoes.aberta } : {}"
      >
        <CBox
          px="20px"
          pb="20px"
        >
          <CFlex
            v-for="(recomendacao, idx) in recomendacoes"
            :key="'rec' + idx"
            alignItems="flex-start"
            :mt="idx > 0 ? '16px' : '0'"
            :pt="idx > 0 ? '16px' : '0'"
            :borderTop="idx > 0 ? '1px solid #EDEDED' : 'none'"
          >
            <CFlex
              flexShrink="0"
              width="36px"
              height="36px"
              borderRadius="50%"
              alignItems="center"
              justifyContent="center"
              mr="12px"
              :bg="recomendacao.fundo"
            >
              <OmtIcons
                :name="recomendacao.icone"
                :color="recomendacao.cor"
              />
            </CFlex>
            <CBox>
              <OmtTypography
                as="p0"
                :color="recomendacao.cor"
                mb="4px"
              >
                {{ recomendacao.rotulo }}
              </OmtTypography>
              <OmtTypography
                as="p1"
                color="#4E4E4E"
                class="texto-relatorio"
              >
                {{ recomendacao.text }}
              </OmtTypography>
            </CBox>
          </CFlex>
        </CBox>
      </component>
    </CBox>
  </CBox>
</template>

<script>
import { CBox, CFlex, CCollapse } from "@chakra-ui/vue";

// Tipo de recomendacao do relatorio da Plataforma Wellness.
const TIPOS_RECOMENDACAO = {
  clinica: { rotulo: "Procure um profissional", icone: "stethoscope", cor: "#B7791F", fundo: "#FFF6E0" },
  wellness: { rotulo: "Hábitos", icone: "heart", cor: "#00A979", fundo: "#EAF8F3" }
};

/**
 * Relatorio da Plataforma Wellness no layout da analise de pele (Skinive): avaliacao e recomendacoes,
 * recolhiveis e abertas por padrao. Resumo, recados da equipe e aviso ficam com a tela.
 * @prop { Object } relatorio assessment e recommendations
 */
export default {
  name: "SkiniverReport",
  components: { CBox, CFlex, CCollapse },
  props: {
    relatorio: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // O CCollapse anima ja na montagem e, ate o primeiro frame, deixa o conteudo escondido. Por isso cada
      // secao comeca como um bloco comum, ja aberto, e so vira CCollapse no primeiro clique ("animada").
      secoes: {
        avaliacao: { aberta: true, animada: false },
        recomendacoes: { aberta: true, animada: false }
      }
    };
  },
  computed: {
    recomendacoes() {
      return (this.relatorio?.recommendations || [])
        .filter(r => r?.text)
        .map(r => ({ ...r, ...(TIPOS_RECOMENDACAO[r.type] || TIPOS_RECOMENDACAO.wellness) }));
    }
  },
  methods: {
    alternar(nome) {
      const secao = this.secoes[nome];
      secao.animada = true;
      secao.aberta = !secao.aberta;
    }
  }
};
</script>

<style scoped>
/* O relatorio pode vir com quebras de linha (ex.: texto editado pela equipe). */
.texto-relatorio {
  white-space: pre-line;
}
</style>
